jQuery(document).ready(function($) {

  // Subscription Plan Form
  var initialSubscription = () => {
    if ( $('input#subscription-save').is(':checked') ) {
      var planID = $('.subscription-frequency__selector .selector-subscribe__choose').val();
      $('#subscription-plan-id').val(planID);
      $('#subscription-plan-id').attr('name', 'selling_plan');
    } else {
      $('#subscription-plan-id').attr('name', '');
    }
  }

  // REVISED updatePricing function to work with window.savings as an object keyed by variant ID
  var updatePricing = () => {
    // Get the currently selected Shopify variant ID from the main product form
    // This input[name="id"] is updated by the theme's variant-picker component
    const selectedVariantId = parseInt($('form[is="product-form"] input[name="id"]').val());

    // Check if we have valid pricing data for this variant ID
    if (isNaN(selectedVariantId) || !window.savings || !window.savings[selectedVariantId]) {
      console.warn('Custom JS: Could not find selected variant ID or pricing data in window.savings for ID:', selectedVariantId);
      return;
    }

    // Retrieve the pricing data specific to the selected variant
    const variantPricingData = window.savings[selectedVariantId];

    // Get the 'onetime' and 'subscribe' pricing objects for this variant
    const onetime = variantPricingData.onetime || {};
    const subscribe = variantPricingData.subscribe || {};

    // Get references to the price display elements
    const $mainProductPrice = $('price-list sale-price'); // Main product price display
    const $onetimeSalePriceSpan = $('.frequency-selector__onetime .subscribe-heading__price--sale');
    const $onetimeComparePriceSpan = $('.frequency-selector__onetime .subscribe-heading__price--compare');
    const $subscribeSalePriceSpan = $('.frequency-selector__subscribe .subscribe-heading__price--sale');
    const $subscribeComparePriceSpan = $('.frequency-selector__subscribe .subscribe-heading__price--compare');
    const $subscribeDiscountSpan = $('.frequency-selector__subscribe .subscribe-heading__discount');
    const $addToCartPriceSpan = $('.buy-buttons .subscription__cta__price');
    const $addToCartSavingText = $('.buy-buttons .subscription__cta--small');


    // Determine which purchase type (One-time or Subscribe) is currently selected by the user
    const isOneshot = $('input#onetime-purchase').is(':checked');

    if (isOneshot) {
      // Update prices based on one-time purchase data for the selected variant
      $mainProductPrice.text(onetime.salePrice || '');
      $onetimeSalePriceSpan.text(onetime.salePrice || '');
      $addToCartPriceSpan.text(onetime.salePrice || '');
      $addToCartSavingText.text(onetime.savePrice ? "You're saving " + onetime.savePrice : '');
    } else { // 'Subscribe' is selected
      // Update prices based on subscription purchase data for the selected variant
      $mainProductPrice.text(subscribe.salePrice || '');
      $subscribeSalePriceSpan.text(subscribe.salePrice || '');
      $addToCartPriceSpan.text(subscribe.salePrice || '');
      $addToCartSavingText.text(subscribe.savePrice ? "You're saving " + subscribe.savePrice : '');
    }

    // Always update compare prices and discount text for both purchase type sections,
    // regardless of which one is currently selected by the radio button.
    // This ensures that if the user switches, the prices are already correct.

    // One-time purchase block:
    if ($onetimeComparePriceSpan.length) {
      if (onetime.comparePrice) {
        $onetimeComparePriceSpan.text(onetime.comparePrice);
        $onetimeComparePriceSpan.show(); // Ensure compare price is visible if present
      } else {
        $onetimeComparePriceSpan.text('');
        $onetimeComparePriceSpan.hide(); // Hide if no compare price
      }
    }
    // Update the sale price for the non-active one-time section as well if it's subscribed
    if (!isOneshot) {
        $onetimeSalePriceSpan.text(onetime.salePrice || '');
    }


    // Subscribe purchase block:
    $subscribeComparePriceSpan.text(subscribe.comparePrice || '');
    // Update the sale price for the non-active subscribe section as well if it's one-time
    if (isOneshot) {
        $subscribeSalePriceSpan.text(subscribe.salePrice || '');
    }
    // Update the discount text for the subscribe block
    $subscribeDiscountSpan.text(subscribe.discountText || '');


    // --- Update discount labels on the variant swatches themselves (1. Buy and Save section) ---
    // This loops through all product option1 radio buttons (pack sizes)
    // and updates their associated discount labels using data from window.savings.
    $('[name="option1"]').each(function() {
      const $thisInput = $(this);
      // Assuming each option1 radio button will have a data-variant-id attribute set in auto-ship-variant-picker.liquid
      const variantIdFromSwatch = $thisInput.data('variant-id');

      if (variantIdFromSwatch && window.savings[variantIdFromSwatch]) {
        // Get the onetime pricing data for this specific variant (swatches usually show onetime discounts)
        const swatchPricingData = window.savings[variantIdFromSwatch].onetime;
        const $label = $thisInput.next('label').find('.discount-label');

        if ($label.length && swatchPricingData) {
          const discountText = swatchPricingData.discountText;
          $label.text(discountText);
          // Add/remove 'disable' class based on whether discount text contains 'No'
          $label.toggleClass('disable', discountText.includes('No'));
        }
      }
    });
  }

  // Initial setup:
  // Call initialSubscription to set selling_plan ID on page load.
  // Call updatePricing after a short delay to ensure window.savings is fully populated from its script.
  if ($('.subscription-frequency__selector').length > 0) {
    initialSubscription();
    setTimeout(updatePricing, 100); // 100ms delay to ensure window.savings is ready
  }

  // Event listener for clicks on the 'One-time purchase' or 'Subscribe' radio buttons
  $('body').on('click', '.subscription-frequency__selector .frequency-selector', function(e) {
    var $this = $(this);

    // Prevent propagation if clicking on the select box itself within the subscribe option
    if (!$(e.target).is('.selector-subscribe__choose') && !$this.hasClass('frequency-selector--active')) {
      $('.frequency-selector').removeClass('frequency-selector--active'); // Deactivate others
      $this.addClass('frequency-selector--active'); // Activate clicked one
      $this.find('input[name="subscribe-radio"]').prop('checked', true); // Check the radio button inside
      initialSubscription(); // Update selling_plan ID based on new selection
      updatePricing(); // Re-calculate and update all prices
    }
  });

  // Event listener for 'variant:change' dispatched by the theme's variant-picker component
  // This is triggered when a new pack size (option1) is selected.
  $(document).on('variant:change', function(e) {
    updatePricing(); // Call updatePricing to update all prices based on the new variant
  });

  // Event listener for changes in the subscription frequency dropdown (e.g., "Delivery every 30 Days")
  $('.subscription-frequency__selector .selector-subscribe__choose').on('change', function() {
    var planID = $(this).val();
    $('#subscription-plan-id').val(planID); // Update the hidden input for Recharge's selling plan ID
    initialSubscription(); // Ensure selling_plan name is correctly set based on selection
  });


  // --- Bundles Product related JavaScript (keep as is) ---
  const $btnAddToCart = $('.add-byo')
  const $mainGallery = $('.byo-gallery-main')
  const $selectPack = $('.byo-form .select-pack')
  const $galleryBYO = $('.byo-gallery')
  const $formBYO = $('.byo-form')
  const limit = $formBYO.attr('data-limit')
  
  $selectPack.click(function (){
    $selectPack.removeClass('active')
    $(this).addClass('active')
    const val = $(this).attr('data-value')
    changePack(val)
  })

  function changePack(val) {
    if(val === 'premium') {
      $galleryBYO.addClass('is-premium')
      $formBYO.addClass('is-premium')
    } else {
      $galleryBYO.removeClass('is-premium')
      $formBYO.removeClass('is-premium')
    }
    resetSelection()
  }

  function resetSelection() {
    $('.pack-item-qty').each(function (){
      $(this).val(0)
      $(this).attr('data-total-price', 0)
    })
    $(`.byo-gallery-quantity .byo-image`).each(function (){
      $(this).find('.variant-qty').html(0)
      $(this).hide()
    })
    totalBundleCalc(0, 0, limit)
  }

  $('.byo-gallery-main .byo-image').click(function (){
    const currentId = $(this).attr('data-variant-id')
    $(`.pack-increase[data-variant-id="${currentId}"]`).click()
  })

  $('.pack-increment').click(function (){
    let newVal = 0
    const sum = getTotalQty()
    const $input = $(this).parent().find('.pack-item-qty')
    const currentPrice = parseInt($input.attr('data-variant-price'))
    const currentVal = parseInt($input.val())
    const currentId = parseInt($input.attr('data-variantid'))

    if($(this).hasClass('pack-decrease')){
      if (currentVal > 0) newVal = currentVal - 1
    } else if (sum < limit) {
      newVal = currentVal + 1
    } else {
      return
    }

    const $imageContainer = $(`.byo-gallery-quantity .byo-image[data-variant-id=${currentId}]`)
    const $imageQty = $imageContainer.find('.variant-qty')
    if(newVal > 0){
      $imageContainer.show()
    } else {
      $imageContainer.hide()
    }
    newVal > 4 ? $imageContainer.attr('data-qty', 'all') : $imageContainer.attr('data-qty', newVal)
    $imageQty.html(newVal)
    $input.val(newVal) && $input.attr('data-total-price', newVal * currentPrice)
    totalBundleCalc(getTotalQty(), getTotalPrice(), limit)
  })

  $btnAddToCart.click(function (e){
    e.preventDefault()
    if ($('.frequency-selector--active').hasClass('frequency-selector__onetime')) {
      addBundleToCart('onetime');
    } else {
      addBundleToCart('subscription', $('.selector-subscribe__choose').val());
    }
  })

  $('.cart__remove_bundle').click(function (e){
    e.preventDefault()
    const ids = $(this).attr('data-item-id').split(',')
    let data = {}
    $(this).parents('.bundle-item').addClass('animated fadeOutLeft')
    for(let id of ids){
      data[id] = 0
    }
    $.post('/cart/update.js', {
      updates: data
    }).done(function (response){
      window.location.reload()
    });
  })

  function getTotalQty() {
    let sum = 0
    $('.pack-item-qty').each(function(){
      sum += parseInt($(this).val())
    })
    return sum
  }

  function getTotalPrice() {
    let sum = 0
    $('.pack-item-qty').each(function(){
      sum += parseInt($(this).attr('data-total-price'))
    })
    return sum
  }

  function totalBundleCalc(sum, price, limit) {
    // Note: window.formatMoney might be undefined if not provided by theme.
    // If it's undefined, this line will cause an error.
    // Assuming 'window.formatMoney' is defined globally by your theme.
    $('.pack-price').html(window.formatMoney(price, $('body').data('money-format')))
    $('.pack-qty').html(sum)
    if(sum < limit) {
      $('.byo-message').html(`CLICK PACKS TO BUILD YOUR OWN. ${sum} / ${limit}`)
      $btnAddToCart.addClass('disabled')
      $mainGallery.removeClass('hide')
    } else {
      $('.byo-message').html(`${sum} / ${limit} PACK SELECTED, ADD TO CART.`)
      $btnAddToCart.removeClass('disabled')
      $mainGallery.addClass('hide')
    }
  }

  function addBundleToCart(type, rechargeId) {
    let data = []
    $('.pack-item-qty').each(function() {
      const qty = parseInt($(this).val())
      const id = $(this).attr('data-variantid')
      if (qty > 0) {
        let item = {
          quantity: qty,
          id: id,
          properties: {
            '_BYO_TYPE': type,
            '_BYO_ID': new Date().getTime()
          }
        }
        if (rechargeId) item['selling_plan'] = rechargeId
        data.push(item)
      }
    })
    $.post('/cart/add.js', {
      items: data
    }).done(function (response){
      window.location.href = '/cart'
    });
  }
});

// THIS BLOCK IS NOW REMOVED/COMMENTED OUT.
// It was redundant and used an incorrect lookup method for window.savings.
/*
document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  if (!variant || !window.savings) return;

  const pack = variant.option1;
  const type = variant.option2;

  // Loop through each price block on page
  const priceBlocks = document.querySelectorAll('.subscribe-heading__price');

  priceBlocks.forEach((block) => {
    const blockPack = block.dataset.pack;
    const blockType = block.dataset.type;

    // Use pack and type as keys to access the correct saved price
    const matched = window.savings[blockPack]?.[blockType];
    if (!matched) return;

    const compareEl = block.querySelector('.subscribe-heading__price--compare');
    const saleEl = block.querySelector('.subscribe-heading__price--sale');

    if (compareEl) {
      if (matched.comparePrice > matched.salePrice) {
        compareEl.textContent = matched.comparePriceFormatted;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (saleEl) {
      saleEl.textContent = matched.salePriceFormatted;
    }
  });

  // Update discount badge (Subscribe block)
  const subDiscountEl = document.querySelector('.subscribe-heading__discount');
  const subMatch = window.savings[pack]?.["Subscribe"];
  if (subDiscountEl && subMatch?.discountPercent) {
    subDiscountEl.textContent = `Save ${subMatch.discountPercent}%`;
  }
});
*/